/**
 * Lovable flow separator presets (centered circle + lucide icon).
 * Matches prototype: py-8 row, w-16/h-16 or w-20/h-20 gradient ring.
 */
export const LOVABLE_FLOW_SEPARATOR = {
  RAW_MATERIALS: "raw-materials",
  TRANSPORT: "transport",
  ENERGY: "energy",
  MANUFACTURING: "manufacturing",
  SETTINGS: "settings",
  INSTALLATION: "installation",
  SERVICE_LIFE: "service-life",
  USE: "use",
  MAINTENANCE: "maintenance",
  REPAIR: "repair",
  REPLACEMENT: "replacement",
  REFURBISHMENT: "refurbishment",
  END_OF_LIFE: "end-of-life",
  DISPOSAL: "disposal",
};
